import NavContent from "shared/components/NavContent/NavContent";

export default () => {
  return <NavContent title="404">page not found</NavContent>;
};
